"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initResizeListener = initResizeListener;

var _theme = _interopRequireDefault(require("../../../theme"));

var _IsServerSideRendering = _interopRequireDefault(require("./IsServerSideRendering"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getSizes(_ref) {
  var height = _ref.height,
      width = _ref.width;
  var widthXs = width < _theme.default.breakpoints.values.sm;
  var widthSm = width >= _theme.default.breakpoints.values.sm && width < _theme.default.breakpoints.values.md;
  var widthMd = width >= _theme.default.breakpoints.values.md && width < _theme.default.breakpoints.values.lg;
  var widthLg = width >= _theme.default.breakpoints.values.lg && width < _theme.default.breakpoints.values.xl;
  var widthXl = width >= _theme.default.breakpoints.values.xl;
  var isPortrait = height > width;
  var isLandscape = !isPortrait;
  return {
    screenSize: {
      width: width,
      height: height,
      widthXs: widthXs,
      widthSm: widthSm,
      widthMd: widthMd,
      widthLg: widthLg,
      widthXl: widthXl,
      isPortrait: isPortrait,
      isLandscape: isLandscape,
      isMobile: widthXs,
      isTablet: widthSm,
      isDesktop: widthMd || widthLg || widthXl
    }
  };
}

function initResizeListener(context) {
  var breakpoint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _theme.default.breakpoints.values.lg;
  var DEFAULT_HEIGHT = 1000;
  var DEFAULT_WIDTH = breakpoint;
  context.setState(_objectSpread({}, context.state, getSizes({
    height: _IsServerSideRendering.default ? DEFAULT_HEIGHT : window.innerHeight,
    width: _IsServerSideRendering.default ? DEFAULT_WIDTH : window.innerWidth
  })));

  if (_IsServerSideRendering.default) {
    return;
  }

  var timeout;
  window.addEventListener('resize', function () {
    if (timeout) {
      window.cancelAnimationFrame(timeout);
    }

    timeout = window.requestAnimationFrame(function () {
      context.setState(_objectSpread({}, context.state, getSizes({
        height: window.innerHeight,
        width: window.innerWidth
      })));
    });
  }, false);
}